// @flow
import { DayjsAdapter } from './dayjs'
import type { DateProvider } from './types'

// $FlowIgnore[deprecated-type]
class DateService<T: DateProvider<*>> {
  provider: T

  constructor(provider: T) {
    this.provider = provider
    this.setTimezone()
  }

  initLocale(locale?: string = navigator.language.split('-')[0]) {
    this.provider.initLocale(locale)
  }

  setTimezone(tz?: string = 'Europe/Moscow') {
    this.provider.setTimezone(tz)
  }

  getProvider() {
    return this.provider.getInstance()
  }

  // $FlowIgnore[unclear-type]
  _(...args: any) {
    return this.getProvider()(...args)
  }

  // $FlowIgnore[unclear-type]
  tz(...args: any) {
    return this.getProvider()(...args).tz()
  }

  // $FlowIgnore[unclear-type]
  utc(...args: any) {
    return this.getProvider().utc(...args)
  }

  unix(arg: number) {
    return this.getProvider().unix(arg)
  }
}

const adapter = new DayjsAdapter()
const service = new DateService<typeof adapter>(adapter)

export { service as DateService }
